export default __webpack_public_path__ + "Asset_Basemap_3D.02aafa667195d95a4560873bfd6bcbee.jpg";